import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  applyTypography,
  PersonalRegisterForm,
  BusinessRegisterForm,
  BrandPanel,
  PolicyText,
  useT,
} from '@repo/common';
import { IS_LEGACY_DOMAIN } from '../../utils/brand.js';

const AUTH_BRAND = IS_LEGACY_DOMAIN ? 'oing' : 'koready';

const TABS = ['personal', 'business', 'creator'];
const TAB_LABELS = {
  personal: 'User',
  business: 'Business',
  creator: 'Creator',
};
const TAB_LABELS_KR = {
  personal: '일반 회원',
  business: '기업 회원',
  creator: '크리에이터',
};

const Register = () => {
  const t = useT();
  const location = useLocation();
  const requestedAccountType = new URLSearchParams(location.search).get('type');
  const [activeTab, setActiveTab] = useState(
    requestedAccountType === 'business' ? 'business' : 'personal',
  );

  const handleTabClick = (tab) => {
    if (tab === 'creator') return;
    setActiveTab(tab);
  };

  return (
    <div className='min-h-screen bg-grayscale-gray01 flex justify-center items-center'>
      <div className='hidden lg:block'>
        <BrandPanel brand={AUTH_BRAND} />
      </div>

      <div className='flex flex-col lg:justify-center items-center flex-1 self-stretch p-[30px] pt-[60px] pb-[120px] lg:min-w-[600px] lg:pl-[40px] lg:pr-[80px] lg:pb-0 lg:pt-0'>
        <div className='w-full max-w-[380px] flex flex-col gap-8 lg:gap-[40px]'>
          <div
            className={`hidden lg:flex typo-b16Strong text-center md:text-center items-center justify-center gap-1.5`}
          >
            <span className='text-text-tertiary'>{t('Already have an account?', '이미 계정이 있으신가요?')}</span>
            <Link
              to='/login'
              state={location.state}
              className='text-green-deep03 hover:text-green-deep03/70 active:text-green-deep03/70'
            >
              {t('Log in', '로그인')}
            </Link>
          </div>

          <div className='flex flex-col items-start lg:items-center gap-1'>
            <div className={`typo-h7 lg:typo-title1 text-left lg:text-center`}>
              {t('Create an account', '회원가입')}
            </div>
            <div className='typo-b12Strong text-text-placeholder hidden lg:block'>
              {t('Access all Koready services with one account.', '하나의 계정으로 모든 Koready 서비스를 이용하실 수 있습니다.')}
            </div>
            <div
              className={`lg:hidden flex typo-b14Strong text-center md:text-center items-center justify-center gap-1.5`}
            >
              <span className='text-text-tertiary'>
                {t('Already have an account?', '이미 계정이 있으신가요?')}
              </span>
              <Link
                to='/login'
                state={location.state}
                className='text-green-deep03 hover:text-green-deep03/70 active:text-green-deep03/70'
              >
                {t('Log in', '로그인')}
              </Link>
            </div>
          </div>

          {/* Tabs */}
          <div className='flex flex-col justify-center w-full'>
            <div className='relative flex bg-grayscale-gray02/50 rounded-full p-1 w-full max-w-[500px] gap-1 mb-5 lg:mb-[40px]'>
              <div
                className='absolute top-1 bottom-1 rounded-full bg-grayscale-gray00 shadow-3 transition-transform duration-300 ease-in-out'
                style={{
                  width: `calc((100% - 8px) / 3)`,
                  transform: `translateX(${TABS.indexOf(activeTab) * 100}%)`,
                }}
              />

              {TABS.map((tab) => (
                <button
                  key={tab}
                  type='button'
                  disabled={tab === 'creator'}
                  aria-disabled={tab === 'creator'}
                  onClick={() => handleTabClick(tab)}
                  style={tab === 'creator' ? { cursor: 'not-allowed' } : undefined}
                  className={`relative flex-1 text-center py-[10px] px-3 rounded-full outline-none focus-visible:ring-2 focus-visible:ring-green-deep02/30 transition-colors duration-200 typo-b14Strong z-10
                    ${
                      activeTab === tab
                        ? 'text-text-primary'
                        : tab === 'creator'
                          ? 'text-text-secondary cursor-not-allowed'
                          : 'text-text-secondary cursor-pointer hover:text-text-primary'
                    }`}
                >
                  {t(TAB_LABELS[tab], TAB_LABELS_KR[tab])}
                </button>
              ))}
            </div>

            {/* Form */}
            <div className='w-full'>
              {activeTab === 'personal' && (
                <PersonalRegisterForm isCreator={false} />
              )}
              {activeTab === 'business' && <BusinessRegisterForm />}
              {activeTab === 'creator' && (
                <PersonalRegisterForm isCreator={true} />
              )}
            </div>
          </div>

          <div>
            <PolicyText />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
